import React from 'react'
import { setCookie } from 'cookies-next'
import { v4 as uuid } from 'uuid'
import { LinkButton } from '@/atoms/Button'
import { PayItForwardIcon } from '@/atoms/Icons/PayItForwardIcon'
import { paths } from '@/constants'
import { Offer } from '@/services/PifService'
import { getPriceForCurrency } from '@/services/PriceFormatter'
import { MoneyCurrencyCode } from '@/types/codegen-federation'
import { useSafeTrack } from '@/utils/analytics'
import { useEcommerceEvents } from '@/utils/analytics/ecommerce-events'

interface TheatricalExpressCheckoutButtonProps {
  projectSlug: string
  selectedOffer: Offer | undefined
  isSubscription?: boolean
}

export const TheatricalExpressCheckoutButton: React.FC<TheatricalExpressCheckoutButtonProps> = ({
  selectedOffer,
  projectSlug,
  isSubscription,
}) => {
  const track = useSafeTrack()
  const { trackProductAdded } = useEcommerceEvents()
  if (!selectedOffer) return null
  const { id, slug, name, price, currency, region } = selectedOffer
  const trackCheckoutStarted = ({ isSubscription }: { isSubscription: boolean }) => {
    const checkoutId = uuid()
    setCookie('pif_checkout_id', checkoutId)

    const checkoutStartedPayload = {
      category: 'pif',
      project: projectSlug,
      products: [
        {
          product_id: id,
          sku: slug,
          category: 'pif',
          name: name,
          price: price,
          currency: currency,
          region: region,
          quantity: 1,
          url: `${paths.getBaseURL()}${paths.payItForward.index}/${projectSlug}/checkout/${id}`,
        },
      ],
      subscription: isSubscription,
      currency: currency,
      region: region,
      tax: 0,
      shipping: 0,
      potential_revenue: getPriceForCurrency(price, currency),
      checkout_id: checkoutId,
    }
    // TODO: deprecated - remove after release of trackProductAdded and marketing's (Kylo's) blessing
    track('Checkout Started', checkoutStartedPayload)

    trackProductAdded({
      funnel: 'pif',
      product_id: id,
      sku: slug,
      category: 'pif',
      name,
      price: getPriceForCurrency(price, currency),
      currency: currency as MoneyCurrencyCode,
      quantity: 1,
      url: `${paths.getBaseURL()}${paths.payItForward.index}/${projectSlug}/checkout/${id}`,
      projectSlug,
    })
  }

  const offerPath = `${paths.payItForward.index}/${projectSlug}/checkout/${id}`

  return (
    <LinkButton
      href={offerPath}
      variant="oxide-core"
      className="mt-6 h-[56px] w-full rounded-2xl"
      onClick={() => {
        trackCheckoutStarted({ isSubscription: isSubscription || false })
      }}
    >
      <PayItForwardIcon color={'gray-900'} className="mr-1.5" />
      Pay it Forward
    </LinkButton>
  )
}
